/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const  getQuadraSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  filtro.fields = ['*']
  return filtro
}

export const setFiltroQuadraSCH = (perPage, filtro)=> {
  filtro.perPage = perPage
  return filtro
}
export const QuadraSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['quadras.descricao', 'numero',  'empreendimentos.nome as empreendimento']
    filtro.addOrder('quadras.descricao', 'asc')
    filtro.join.addLeft('empreendimentos','empreendimentos.empreendimento_id','quadras.empreendimento_id')
  return filtro
}
